import {
  Box,
  Text,
  Divider,
  Grid,
  ReadOnlyField,
  FieldArrayWithId,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import React from 'react';
import { ExplorerSignupRequestSerializer } from '@bcba/serializers';
import { SignupRequestLegalRepresentativeDocument } from './SignupRequestLegalRepresentativeDocument';
import { VALIDATION_STATUSES } from '@bcba/types';

interface SignUpRequestLegalRepresentativeInfoProps {
  formMethods: any;
  fields: FieldArrayWithId<
    ExplorerSignupRequestSerializer,
    'legalRepresentatives',
    'id'
  >[];
}

export const SignUpRequestLegalRepresentativeInfo = (
  props: SignUpRequestLegalRepresentativeInfoProps,
) => {
  const { formMethods, fields } = props;
  const { t } = useTranslation();

  return (
    <>
      {fields?.map((representative, index) => {
        const {
          idDocument,
          signupPermissionDocument,
          status,
          validationMessage,
        } = representative;
        const keyNameDropzone = `legalRepresentatives.${index}.`;
        const showsignupPermissionDocumentField =
          Boolean(signupPermissionDocument) ||
          (Boolean(validationMessage) &&
            status === VALIDATION_STATUSES.PENDING_CHANGE_REQUEST);

        if (showsignupPermissionDocumentField) {
          formMethods.register(
            `${keyNameDropzone}signupPermissionDocument.file`,
            {
              required: Boolean(representative.validationMessage)
                ? t('class-validator.isBase64.error')
                : false,
            },
          );
        }

        return (
          <Box key={representative.id}>
            <Box mb={6} mt={16}>
              <Text size="md" variant="medium" color="content-primary" mb={4}>
                {t('signUpRequest.legalRepresentativeData')} {index + 1}
              </Text>
              <Divider />
            </Box>
            <Grid
              templateColumns={{
                base: 'repeat(1, 1fr)',
                md: 'repeat(2, 1fr)',
              }}
              gridGap={6}
            >
              <ReadOnlyField
                label={t('common.user.name')}
                value={representative.firstName}
              />
              <ReadOnlyField
                label={t('common.user.lastName')}
                value={representative.lastName}
              />
              <ReadOnlyField
                label={t('common.user.documentType')}
                value={representative.idDocumentType}
              />
              <ReadOnlyField
                label={t('common.user.document')}
                value={representative.idDocumentNumber}
              />
              <ReadOnlyField
                label={t('common.user.position')}
                value={t(
                  `businessSignup.form.representativePosition.${representative.position}`,
                )}
              />
              <ReadOnlyField
                label={t('common.user.email')}
                value={representative.email}
              />
            </Grid>
            <SignupRequestLegalRepresentativeDocument
              labelDropzone={t('common.DNI')}
              formMethods={formMethods}
              document={idDocument}
              keyNameDropzone={keyNameDropzone + 'idDocument'}
              isRequired={true}
            />
            {showsignupPermissionDocumentField ? (
              <SignupRequestLegalRepresentativeDocument
                labelDropzone={t(
                  'signUpRequest.form.signUpPermissionFile.label',
                )}
                formMethods={formMethods}
                document={signupPermissionDocument}
                keyNameDropzone={keyNameDropzone + 'signupPermissionDocument'}
                isRequired={
                  Boolean(representative.validationMessage)
                    ? t('class-validator.isBase64.error')
                    : false
                }
                requestUploadFileMessage={representative?.validationMessage}
              />
            ) : null}
          </Box>
        );
      })}
    </>
  );
};

export default SignUpRequestLegalRepresentativeInfo;
